if (window.getCookie('CC__oglasevalski_piskotki__') != 0) {
    window.googleAdCreateScript();

    googletag.cmd.push(function () {
        Object.entries(window.googleAdSlots).forEach(([slotDiv, slotConfig]) => {

            if (slotConfig.sizeMapping) {
                const googleSizeMapping = googletag.sizeMapping();

                slotConfig.sizeMapping.forEach(mapping => {
                    googleSizeMapping.addSize(mapping.browserSize, mapping.slotSizes);
                });

                slotConfig.sizeMappingBuild = googleSizeMapping.build();
            }

            const definedSlot = slotConfig.isOutOfPage
                ? googletag.defineOutOfPageSlot(
                    slotConfig.adUnitPath,
                    slotDiv == "INTERSTITIAL" ? googletag.enums.OutOfPageFormat.INTERSTITIAL : slotDiv
                )
                : googletag.defineSlot(
                    slotConfig.adUnitPath, slotConfig.size, slotDiv
                );

            if (slotConfig.sizeMapping) {
                definedSlot.defineSizeMapping(slotConfig.sizeMappingBuild);
            }

            if (slotConfig.isOutOfPage) {
                definedSlot.addService(googletag.companionAds());
            }

            definedSlot.addService(googletag.pubads());

            definedSlot.setConfig({
                targeting: slotConfig.targeting,
                collapseDiv: "ON_NO_FILL",
            });

            slotConfig.definedSlot = definedSlot;
        });

        googletag.setConfig({
            targeting: window.googleAdTargetings
        });

        // OCM script requires setCentering and disable of initial load
        if (window.enabledOcm) googletag.pubads().setCentering(true);

        googletag.pubads().enableSingleRequest();

        // If OCM is enabled, disavle initial load is set after enableSingleRequest.
        if (window.enabledOcm) googletag.setConfig({ disableInitialLoad: true })


        if (window.ppid) {
            googletag.pubads().setPublisherProvidedId(window.ppid);
        }

        googletag.enableServices();
    });
}
